import React, { useState } from 'react'
import { IHonestAsyncSelectInput } from 'types/select.interface'
import { SelectWrapper, Label } from '../Input/Input.styled'
import { HonestAsyncSelect } from './HonestAsyncSelect'
import { Flex, InvalidText } from 'styling/GlobalStyles'

export const HonestSelectAsyncInput = (props: IHonestAsyncSelectInput) => {
  const [openOptions, setOpenOptions] = useState(false)
  const [blured, setBlured] = useState(false)
  const [query, setQuery] = useState('')

  return (
    <SelectWrapper
      key={props.keyProp}
      width={props.width}
      invalid={props.invalid ? 'true' : ''}
      nomarg={props.nomarg}
      view={props.view}
    >
      <Flex>
        <Label htmlFor={props.id} labelText={props.labelText}>
          {props.labelText}
        </Label>
        {props.required && <span style={{ color: 'red' }} >*</span>}
      </Flex>
      <HonestAsyncSelect
        query={query}
        setQuery={setQuery}
        onBlur={() => {
          setBlured(true)
          setTimeout(() => {
            setOpenOptions(false)
          }, 150)
        }}
        invalid={props.invalid}
        {...props}
        blured={blured}
        setBlured={setBlured}
        openOptions={openOptions}
        setOpenOptions={setOpenOptions} />
      <article>{props.invalid && blured && <InvalidText>This field is required</InvalidText>}</article>

    </SelectWrapper>
  )
}
